import type { Messages } from '@/lib/i18n/messages'

/** A legal page's id: the footer words it from `marketingFooter.legal`. */
export type LegalLinkKey = keyof Messages['marketingFooter']['legal']

/**
 * Brew's legal pages on docs.brew.new: the footer links them, and the
 * enterprise page lists them for procurement reviews. `label` is the
 * English name the enterprise page shows until its copy is in a catalog.
 */
export const LEGAL_LINKS: ReadonlyArray<{
  key: LegalLinkKey
  label: string
  href: string
}> = [
  {
    key: 'privacy',
    label: 'Privacy',
    href: 'https://docs.brew.new/legal/privacy-policy',
  },
  {
    key: 'terms',
    label: 'Terms',
    href: 'https://docs.brew.new/legal/terms-of-service',
  },
  {
    key: 'acceptableUse',
    label: 'Acceptable use',
    href: 'https://docs.brew.new/legal/acceptable-use-policy',
  },
  {
    key: 'dpa',
    label: 'DPA',
    href: 'https://docs.brew.new/legal/data-protection-addendum',
  },
  {
    key: 'gdpr',
    label: 'GDPR',
    href: 'https://docs.brew.new/legal/gdpr-and-your-data',
  },
  {
    key: 'subprocessors',
    label: 'Subprocessors',
    href: 'https://docs.brew.new/legal/subprocessors',
  },
]
